var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import DomPurify from "isomorphic-dompurify";
import { __, getConfig } from "@jti/fe-common";
import { Loading, Notification } from "@jti/ui";
import { useAemModel } from "../../contexts/AemModelContext";
import { usePhoneService } from "../../hooks/usePhoneService";
import { useQuery } from "../../hooks/useQuery";
const SmsPhoneValidation = () => {
    const queryParams = useQuery();
    const { verifyOtp, isVerifyOtpLoading, isVerifyOtpFailed } = usePhoneService();
    const { phoneValidationOtp } = useAemModel();
    const { sanitize } = DomPurify;
    const successMessage = (phoneValidationOtp === null || phoneValidationOtp === void 0 ? void 0 : phoneValidationOtp.successValidationViaSmsMessage) || __("login.verify_phone.success");
    const failedMessage = (phoneValidationOtp === null || phoneValidationOtp === void 0 ? void 0 : phoneValidationOtp.successValidationViaSmsMessage) || __("login.verify_phone.failed");
    const requestId = queryParams.get("id");
    const otpCode = queryParams.get("code");
    const verifyOtpCode = useCallback((requestId, otpCode) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield verifyOtp(requestId, otpCode);
        }
        catch (error) {
            console.error(error);
        }
    }), [verifyOtp]);
    useEffect(() => {
        if (requestId && otpCode) {
            verifyOtpCode(requestId, otpCode);
        }
        else {
            window.location.href = `${getConfig().AUTH_PAGE_URL}#/login`;
        }
    }, [otpCode, requestId]);
    if (isVerifyOtpLoading) {
        return _jsx(Loading, {});
    }
    return (_jsx(Notification, { variant: isVerifyOtpFailed ? "error" : "checkmark", children: _jsx("span", { "data-testid": "smsValidationResult", dangerouslySetInnerHTML: {
                __html: sanitize(isVerifyOtpFailed ? failedMessage : successMessage),
            } }) }));
};
export default SmsPhoneValidation;
